import React from "react";
import Mixpanel from "mixpanel-browser";

import { useDecodedAuthPrincipal } from "AuthPrincipal";

const mixpanelToken = process.env.REACT_APP_MIXPANEL_TOKEN;

let mixpanelInit = false;
if (mixpanelToken && process.env.NODE_ENV === "production") {
  Mixpanel.init(mixpanelToken, {
    debug: process.env.NODE_ENV !== "production",
    persistence: "localStorage",
  });
  mixpanelInit = true;
}

export const useTrackingIdentity = () => {
  const principal = useDecodedAuthPrincipal();

  React.useEffect(() => {
    if (principal && mixpanelInit) {
      Mixpanel.people.set(principal.user.id, {
        accountDisplayName: principal.account.name,
        accountIsPro: principal.account.isPro,
        accountType: principal.account.type,
        userDisplayName: principal.user.displayName,
        userEmail: principal.user.email,
      });
    }
  }, [principal]);
};
